import * as Environment from './EnvironmentConstants';
import {COUNTRIES, HOST} from './AppConstants';
import {SSO_TOKEN_PATH} from './RoutesConstant';
import {s4} from '../../common/utils/StringUtils';

const DEFAULT_PREFIX = 'security-sso';
const VERSION = 'v4';
let SEC_URL = `http://localhost:9010/${DEFAULT_PREFIX}`;
let SSO_KEYCLOAK_HOST = '//demo.login.motorfy.com';

switch (Environment.ENVIRONMENT) {
    case Environment.PRODUCTION_ENV:
        SEC_URL = `https://apis.latamautos.com/${DEFAULT_PREFIX}/${VERSION}`;
        SSO_KEYCLOAK_HOST = '//login.motorfy.com';
        break;
    case Environment.STAGING_ENV:
        SEC_URL = `//staging.apis.latamautos.com/${DEFAULT_PREFIX}/${VERSION}`;
        break;
    case Environment.DEMO_ENV:
        SEC_URL = `//demo.apis.latamautos.com/${DEFAULT_PREFIX}/${VERSION}`;
        break;
}
export const SECURITY_URL = SEC_URL;

export const getKCClient = (country) => {
    let KC_CLIENT = null;
    switch (country) {
        case COUNTRIES.MX.id:
            KC_CLIENT = 'motorcredit_core_mexico';
            break;
    }
    return KC_CLIENT;
};

export const SSO_CLIENT_ID = 'fb';
export const SSO_GRANT_TYPE = 'authorization_code';
export const SSO_REDIRECT_URL = `${HOST}${SSO_TOKEN_PATH}`;
export const SSO_SCOPE = 'openid email';
export const SSO_STATE = `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}`;
export const SSO_COMMON_QUERY_STRING = `&response_type=code&scope=email+openid&state=${SSO_STATE}`;

export const getSSOAuthorizationUrl = country =>
    /* tslint:disable-next-line:max-line-length */
    `${SSO_KEYCLOAK_HOST}/auth/realms/${getKCClient(country)}/protocol/openid-connect/auth?client_id=${SSO_CLIENT_ID}&redirect_uri=${SSO_REDIRECT_URL}${SSO_COMMON_QUERY_STRING}`;

export const getSSOTokenUrl = country =>
    `${SSO_KEYCLOAK_HOST}/auth/realms/${getKCClient(country)}/protocol/openid-connect/token`;

export const getSSOLogoutUrl = country =>
    `${SSO_KEYCLOAK_HOST}/auth/realms/${getKCClient(country)}/protocol/openid-connect/logout`;
